import { createContext, useState } from 'react';
import api from 'services/api';

export const ComodatoContext = createContext();

export const ComodatoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [comodato, setComodato] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getComodato = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: comodato?.filter,
        page: comodato?.page,
        size: comodato?.size,
        order: comodato?.order,
        ...payload,
      });
      setComodato((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ComodatoContext.Provider
      value={{
        comodato,
        getLoading,
        getComodato,
      }}
    >
      {children}
    </ComodatoContext.Provider>
  );
};
